module.exports = __webpack_public_path__ + "img/logo-header-white.acd382ca.png";